import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import DeliveryOrderService from "services/Setup/LoanOrigination/DeliveryOrder/DeliveryOrderService";
import { notification } from "antd";

// Initial state
export const initialState = {
  loading: false,
  message: "",
  statusRespon: "",
  showMessage: false,
  redirect: "",
  getCount: 0,
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  deliveryOrderList: [],
  deliveryOrderSoftCopyList: [],
};

// Thunk: Get Delivery Order List
export const getSearchListDOBAstSlice = createAsyncThunk(
  "DeliveryOrder/getSearchListDOBAstSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await DeliveryOrderService.getSearchListDOBAstService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected error!",
      );
    }
  },
);

export const getSearchListDoApprovalSlice = createAsyncThunk(
  "DeliveryOrder/getSearchListDoApprovalSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await DeliveryOrderService.getSearchListDoApprovalService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected error!",
      );
    }
  },
);

export const addDeliveryOrderSlice = createAsyncThunk(
  "DeliveryOrder/addDeliveryOrderSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await DeliveryOrderService.addDeliveryOrderService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected error!",
      );
    }
  },
);
export const putApproveDeliveryOrderSlice = createAsyncThunk(
  "DeliveryOrder/putApproveDeliveryOrderSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await DeliveryOrderService.putApproveDeliveryOrderService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected error!",
      );
    }
  },
);

export const putRejectedDeliveryOrderSlice = createAsyncThunk(
  "DeliveryOrder/putRejectedDeliveryOrderSlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await DeliveryOrderService.putRejectedDeliveryOrderService(userInput);
      if (response.status === 200) {
        if (response.data.status == "Success") {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected error!",
      );
    }
  },
);

export const getDeliveryOrderSoftCopySlice = createAsyncThunk(
  "DeliveryOrder/getDeliveryOrderSoftCopySlice",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await DeliveryOrderService.getDeliveryOrderSoftCopyService(userInput);
      if (response.status === 200 && response.data) {
        return response.data;
      } else {
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected error!",
      );
    }
  },
);

// Slice
const DeliveryOrder = createSlice({
  name: "deliveryOrder",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
    resetState: (state) => {
      state.loading = false;
      state.message = "";
      state.statusRespon = "";
      state.showMessage = false;
      state.redirect = "";
      state.result = {};
      state.deliveryOrderList = [];
      state.getCount = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      // Get delivery order list
      .addCase(getSearchListDOBAstSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchListDOBAstSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveryOrderList = action.payload || [];
        state.getCount = action.payload.count;
        // state.statusRespon = "Success";
      })
      .addCase(getSearchListDOBAstSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // Add delivery order
      .addCase(addDeliveryOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(addDeliveryOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload || {};
        state.statusRespon = action.payload?.status;
      })
      .addCase(addDeliveryOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // getSearchListDoApprovalSlice
      .addCase(getSearchListDoApprovalSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSearchListDoApprovalSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.deliveryOrderList = action.payload || [];
        state.getCount = action.payload?.count ?? action.payload?.data?.length ?? 0;
        // state.statusRespon = "Success";
      })
      .addCase(getSearchListDoApprovalSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // putApproveDeliveryOrderSlice
      .addCase(putApproveDeliveryOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(putApproveDeliveryOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload || {};
        state.statusRespon = action.payload?.status;
      })
      .addCase(putApproveDeliveryOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // putRejectedDeliveryOrderSlice
      .addCase(putRejectedDeliveryOrderSlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(putRejectedDeliveryOrderSlice.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload || {};
        state.statusRespon = action.payload?.status;
      })
      .addCase(putRejectedDeliveryOrderSlice.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
        state.statusRespon = "Error";
      })
      // getDeliveryOrderSoftCopySlice

      .addCase(getDeliveryOrderSoftCopySlice.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDeliveryOrderSoftCopySlice.fulfilled, (state, action) => {
        console.log("getDeliveryOrderSoftCopySlice fulfilled", action.payload);
        
        state.loading = false;
        state.deliveryOrderSoftCopyList = action.payload  ; 
      })
      .addCase(getDeliveryOrderSoftCopySlice.rejected, (state, action) => {
        state.loading = false;
        state.deliveryOrderSoftCopyList = [];
        state.showMessage = true; 
      });
  },
});

// Exports
export const { showNotification, hideNotification, showLoading, resetState } =
  DeliveryOrder.actions;

export default DeliveryOrder.reducer;
